import React from 'react';
import PropTypes from 'prop-types';
import {Field} from 'redux-form';

import Form from '@appComponents/ReduxFormControls';

export const InvoiceStatusesFilter = ({
    loading = false,
    filters,
    restoreFilterValues,
    invoiceStatuses,
}) => (
    <Field
        className='--customWidth --invoiceStatus'
        component={Form.ReduxSelect}
        disabled={loading}
        loading={loading}
        multiple
        name='invoiceStatuses'
        placeholder='Invoice status'
        options={invoiceStatuses}
        search
        setValue={restoreFilterValues(filters, 'invoiceStatuses')}
    />
);

InvoiceStatusesFilter.propTypes = {
    loading: PropTypes.bool,
    filters: PropTypes.object.isRequired,
    restoreFilterValues: PropTypes.func.isRequired,
    invoiceStatuses: PropTypes.array.isRequired,
};
